import { ControlUI } from '../base';
import * as marietta from '../..';
import * as digifie from '../../../digifie';

/* TopView2D
 * ウォークスルー時の平面図.
 */
export default class TopView2D extends ControlUI {
    _instance: digifie.view.TopVew2D;

    _position: { x: number, y: number };

    _rotation: number;

    public get me(): digifie.view.TopVew2D { return this._instance; }

    public set me(i: digifie.view.TopVew2D) { this._instance = i; }

    public draw() { this.me.drawTopView(this._floor); }

    public get floor(): number { return this._floor; }

    public set floor(fl: number) {
      this._floor = fl;
      marietta.webcad.WebCADGlobal.miniMapManager.changeFloor(fl);
    }

    public get position(): { x: number, y: number } { return this._position; }

    public set position(pt: { x: number, y: number }) {
      this._position.x = pt.x;
      this._position.y = pt.y;

      if (marietta.webcad.WebCADGlobal.miniMapManager.current !== undefined &&
          marietta.webcad.WebCADGlobal.miniMapManager.current !== null) { marietta.webcad.WebCADGlobal.miniMapManager.current.move(this._position.x, this._position.y); }
    }

    public get rotation(): number { return this._rotation; }

    public set rotation(rot: number) {
      this._rotation = rot;
      if (marietta.webcad.WebCADGlobal.miniMapManager.current !== undefined &&
          marietta.webcad.WebCADGlobal.miniMapManager.current !== null) { marietta.webcad.WebCADGlobal.miniMapManager.current.rotate(this._rotation); }
    }

    private _visible: boolean;

    public get visible(): boolean { return this._visible; }

    public set visible(vis: boolean) {
      if (vis) this.me.show();
      else this.me.hide();
      this._visible = vis;
    }

    private _floor: number;

    constructor(id: string, right: number, top: number, container: HTMLElement) {
      super();

      this.me = new digifie.view.TopVew2D(id, right, top, container);
      this._floor = 1;
      this._visible = false;

      this._position = { x: 0, y: 0 };
      this._rotation = 0;
    }
}
